import { DomainEvent } from 'src/app/core/domain/events/domain_event';

import { Memo } from '../../memo/memo';

export class MemoEvent extends DomainEvent<Memo> {}

export class MemoCreated extends MemoEvent {}

export class MemoUpdated extends MemoEvent {}
